<template>
    <div class="content-raw-data-wrapper">
        <!-- Search Bar -->
        <v-expansion-panels flat v-model="showRawData">
            <v-expansion-panel>
                <v-expansion-panel-title>
                    <h3>Raw Data</h3>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <v-text-field v-model="searchQuery" class="content-data-search" flat label="Suche"
                        prepend-inner-icon="mdi-magnify" variant="outlined" density="compact" hide-details single-line
                        rounded="lg"></v-text-field>
                    <div v-for="(value, key) in filteredCustomers" :key="key" class="dialog-raw-data-content">
                        <h4>{{ key }}</h4>
                        <p>{{ value || "--" }}</p>
                    </div>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    props: {
        customers: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showRawData: false,
            searchQuery: '' // Initialize searchQuery
        };
    },
    computed: {
        handleRawDataIcon() {
            return this.showRawData ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        filteredCustomers() {
            if (!this.searchQuery) return this.customers;
            const searchLower = this.searchQuery.toLowerCase();
            return Object.entries(this.customers).reduce((acc, [key, value]) => {
                if (key.toLowerCase().includes(searchLower) || String(value).toLowerCase().includes(searchLower)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
        }
    },
    methods: {
        handleShowRawData() {
            this.showRawData = !this.showRawData;
        }
    }
};
</script>

<style lang="scss" scoped>

</style>